import {
    FCL_EXPORT_BOOKING_REPORT_CONTAINER_TEUS,
    FCL_EXPORT_BOOKING_REPORT_LIST,
    FCL_EXPORT_BOOKING_REPORT_SUMMARY,
    FCL_EXPORT_SALESPERSON_REPORT_CONTACT_LIST,
    FCL_EXPORT_SALESPERSON_REPORT_CONTAINER_TEUS,
    FCL_EXPORT_SALESPERSON_REPORT_LIST,
    FCL_EXPORT_SALESPERSON_REPORT_SALES_PERSON_TEUS,
    FCL_EXPORT_SALESPERSON_REPORT_SUMMARY,
} from "./constant";

export const initStateFeed = {
    exportBookingReportList: [],
    exportBookingReportSummary: {},
    exportBookingReportContainerTeus: [],
    exportSalespersonReportList: [],
    exportSalespersonReportSummary: {},
    exportSalespersonReportContainerTeus: [],
    exportSalespersonReportSalesPersonTeus: [],
    exportSalespersonReportContactList: [],
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case FCL_EXPORT_BOOKING_REPORT_LIST:
            return {
                ...state,
                exportBookingReportList: action.payload,
            };
        case FCL_EXPORT_BOOKING_REPORT_SUMMARY:
            return {
                ...state,
                exportBookingReportSummary: action.payload,
            };
        case FCL_EXPORT_BOOKING_REPORT_CONTAINER_TEUS:
            return {
                ...state,
                exportBookingReportContainerTeus: action.payload,
            };
        case FCL_EXPORT_SALESPERSON_REPORT_LIST:
            return {
                ...state,
                exportSalespersonReportList: action.payload,
            };
        case FCL_EXPORT_SALESPERSON_REPORT_SUMMARY:
            return {
                ...state,
                exportSalespersonReportSummary: action.payload,
            };
        case FCL_EXPORT_SALESPERSON_REPORT_CONTAINER_TEUS:
            return {
                ...state,
                exportSalespersonReportContainerTeus: action.payload,
            };
        case FCL_EXPORT_SALESPERSON_REPORT_SALES_PERSON_TEUS:
            return {
                ...state,
                exportSalespersonReportSalesPersonTeus: action.payload,
            };
        case FCL_EXPORT_SALESPERSON_REPORT_CONTACT_LIST:
            return {
                ...state,
                exportSalespersonReportContactList: action.payload,
            };
        default:
            return state;
    }
};
